// Inspired by https://blog.thoughtspile.tech/2021/11/30/lazy-useref/

import { type RefObject, useRef } from 'react'

const empty = Symbol('empty')

/**
 * Equivalent to useRef, except the initial value is a function that is only
 * invoked initially.
 */
export const useLazyRef = <T>(getInitialValue: () => T): RefObject<T> => {
	const ref = useRef<T | symbol>(empty)

	if (ref.current === empty) {
		ref.current = getInitialValue()
	}

	return ref as RefObject<T>
}
